import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ValueField } from 'src/app/settings/model/value-field';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { EVENT_OCCERRENCE_TIME_SC, RECEIVE_TIME_SC } from 'src/app/common/const';

@Component({
  selector: 'app-filter-builder-field-select',
  templateUrl: './filter-builder-field-select.component.html',
  styleUrls: ['./filter-builder-field-select.component.scss']
})
export class FilterBuilderFieldSelectComponent implements OnInit {

  @ViewChild('searchInput', { static: true })
  searchInput: ElementRef<HTMLInputElement>;

  @Input()
  fieldControl: AbstractControl;

  @Input()
  fields: ValueField[] = [];

  @Output()
  selectionChange = new EventEmitter<ValueField>();

  availableValues: Map<ValueField, string> = new Map();
  filteredValues: Observable<ValueField[]>;

  lastSelected: ValueField | null = null;

  constructor(
    private settings: UserSettingsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.fieldControl.value instanceof ValueField) {
      this.lastSelected = this.fieldControl.value;
    }
    this.availableValues = new Map(this.fields.map(value => {
      const displayValue = this.getValueFieldName(value);
      return [value, displayValue];
    }));
    this.subscribeToInputChanges();
  }

  private subscribeToInputChanges(): void {
    this.filteredValues = this.fieldControl.valueChanges
      .pipe(
        startWith(''),
        map(value => value ? this.filter(value) : this.fields.slice())
      );
  }

  private filter(value: string | ValueField): ValueField[] {
    if (value instanceof ValueField) return this.fields.slice();
    const filterValue = typeof value === 'string' ? value.toLowerCase() : null;
    if (!filterValue) return [];
    return Array.from(this.availableValues.entries()).filter(([_, v]) => this.translate.instant(v).toLowerCase().includes(filterValue)).map(([k, _]) => k);
  }

  getValueFieldName(value: ValueField): string {
    if (this.settings.isEventOccurenceTimeEnabled() && value.name == RECEIVE_TIME_SC) {
      return EVENT_OCCERRENCE_TIME_SC;
    }
    return value.title ?? value.name;
  }

  displayFn = (value: ValueField | null): string => {
    if (!value) return '';
    else return this.translate.instant(this.availableValues.get(value));
  };

  onOptionSelected(value: ValueField): void {
    this.lastSelected = value;
    this.selectionChange.emit(value);

    setTimeout(() => {
      this.searchInput?.nativeElement.blur();
    });
  }

  onInputFocus(): void {
    if (this.fieldControl.value instanceof ValueField) {
      this.fieldControl.setValue(this.fieldControl.value, { emitEvent: true });
    }
    setTimeout(() => {
      this.searchInput?.nativeElement.select();
    });
  }

  onInputBlur(): void {
    if (!(this.fieldControl.value instanceof ValueField)) {
      this.fieldControl.setValue(this.lastSelected ?? null, { emitEvent: true });
    }
  }

}
